import { useTranslation } from 'react-i18next'
import { FlaskConical, Laptop, TriangleAlert } from 'lucide-react'
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from '@/components/ui/item'
import { apiEnvironment, apiHost, isLocalhostUi, type ApiEnvironment } from '@/utils/environment'

const ENV_STYLES: Record<ApiEnvironment, { icon: typeof Laptop; className: string }> = {
  local: { icon: Laptop, className: 'border-(--ad-env-local-border) bg-(--ad-env-local-bg) text-(--ad-env-local)' },
  dev: { icon: FlaskConical, className: 'border-(--ad-env-dev-border) bg-(--ad-env-dev-bg) text-(--ad-env-dev)' },
  staging: { icon: FlaskConical, className: 'border-(--ad-env-dev-border) bg-(--ad-env-dev-bg) text-(--ad-env-dev)' },
  prod: { icon: TriangleAlert, className: 'border-(--ad-env-prod-border) bg-(--ad-env-prod-bg) text-(--ad-env-prod)' },
}

/** Flags which API environment a locally served UI is connected to. Renders nothing on deployed builds. */
export function EnvironmentCard({ className }: { className?: string }) {
  const { t } = useTranslation()
  if (!isLocalhostUi) return null
  const { icon: EnvIcon, className: envClassName } = ENV_STYLES[apiEnvironment]

  return (
    <Item variant="outline" size="sm" className={`${envClassName} ${className ?? ''}`}>
      <ItemMedia>
        <EnvIcon className="size-4" />
      </ItemMedia>
      <ItemContent className="min-w-0 gap-0">
        <ItemTitle>{t(`environment.${apiEnvironment}`)}</ItemTitle>
        <ItemDescription className="truncate text-xs text-current opacity-80">{apiHost}</ItemDescription>
      </ItemContent>
    </Item>
  )
}
